import { HostListener, Component, AfterContentChecked, ViewChild,OnInit ,ElementRef} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NgbPaginationModule, NgbPaginationConfig ,NgbModalRef,NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsListBE } from '../packaging-instruction/shared/packaging-instruction.model';
import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { PackagingSearchService } from './packaging-instruction-search.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { UserHandling } from '../shared/user-handling';
import { NgbDateFRParserFormatter } from '../shared/ngb-date-fr-parser-formatter';
import { AttributeListBE } from '../shared/attribute-list.model';
import { AppConfig } from '../config/app.config';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { SetFocus } from '../../app/shared/setFocus';
import { flatten } from '@angular/router/src/utils/collection';
import { Checkbox } from 'primeng/primeng';
import { Console, log } from 'console';
import { isNgTemplate } from '@angular/compiler';

interface allRegions {
    value: number;
    viewValue: string;
  }


@Component({
    moduleId: module.id,
    selector: 'packaging-instruction-search',
    templateUrl: 'packaging-instruction-search.html',
    providers: [PackagingSearchService, NgbPaginationConfig]
})

export class PackagingSearchComponent implements OnInit, AfterContentChecked, ComponentCanDeactivate {
    // lists
    listOfPI: Array<InstructionsListBE>;
    listOfPITemp: Array<InstructionsListBE> = null;
    pagePiData: Array<InstructionsListBE> = [];
    pagePiData1:Array<InstructionsListBE>; 
    pagePiData2:Array<InstructionsListBE> ;
    listOfUniquePI: Array<InstructionsListBE>;
    listOfAllPI: Array<InstructionsListBE>;
    listOfAllDistinctPI: Array<InstructionsListBE>;
    statusesList: AttributeListBE[] = [];
    pruList: AttributeListBE[] = [];

    // Confirm dialog box
    @ViewChild('validate') validate: ElementRef;
    dialogAction: string;
    dialogBtnType: string;
    dialogAppliesTo: string = "";
    dialogAppliesToId: number = -1;
    confirmDlgText: string = "";
    currentDlg: NgbModalRef;

    // objects
    user: UserHandling = new UserHandling();
    dateFormatter: NgbDateFRParserFormatter = new NgbDateFRParserFormatter();

    // paging
    pagerPage = 1;
    numPages = 1;
    collectionSize = 0;
    numPages1=1;
    collectionSize1=0;

    // search
    searchPartNo = '';
    searchPartName = '';
    searchSupplierNumber = '';
    searchExtendedSupplierNumber: string;
    searchSupplierName = '';
    searchStatusIds: number[] = [];
    searchIssuerUserId = '';
    searchIssuerUserName = '';
    searchMHNO = '';
    searchUnit = '-1';
    searchCreatedDateFrom: NgbDateStruct = this.dateFormatter.parse("2015-01-01");
    searchCreatedDateTo: NgbDateStruct = this.dateFormatter.parse("2025-12-31");
    searchRegion = 2;

    inlcludeNullCreatedDateInResult = true;
    includePI = true;
    excludeSupplier = false;
    searchSequenceInstructionInResult = true;
    searchPackagingInstructionInResult = true;

    // sort and filter
    sortField = 'CreatedDate';
    sortOrder = 'desc';
    filterField = '';
    filterText = '';
    searchIsExecuting = false;

    // misc
    showSpinner = false;
    setFocus: SetFocus = new SetFocus();
    isFocusSet = false;
    piName = '';

    levelIndexes: number[] = [0, 1, 2, 3];
    flag: number = 0;
    isEdited: boolean;
    isApproved: boolean;
    selectedRegionValue = 4;

    allRegions: allRegions[] = [
      { value: 4, viewValue: 'All' },
      { value: 1, viewValue: 'Internal' },
      { value: 2, viewValue: 'One-Way' },     
      { value: 3, viewValue: 'Returnable' },
    ];
    previousID: any;

    constructor(private config: AppConfig,
        private pkgSearchService: PackagingSearchService,
        private paginationConfig: NgbPaginationConfig,
        private errHandler: ErrorHandlerService,
        private modalService: NgbModal,
    ) {
        paginationConfig.pageSize = 30;
        paginationConfig.ellipses = true;
        paginationConfig.directionLinks = true;
        paginationConfig.boundaryLinks = true;
        paginationConfig.maxSize = 30;
        this.collectionSize = 0;
        this.collectionSize1 = 0;
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return true;
    }


    // ----------------------------------------------------------
    // Life cycle hooks
    // ----------------------------------------------------------
    ngOnInit(): void {
        this.showSpinner = false;
        this.getStatuses();
        this.setDefaultCreateDates();
        this.searchSequenceInstructionInResult = true;
        this.searchPackagingInstructionInResult = true;
        this.searchCreatedDateFrom.day = 1;
        this.searchCreatedDateFrom.month = 1;
        this.searchCreatedDateFrom.year = 1991;
        this.searchRegion = 3;

        this.searchCreatedDateTo = this.dateFormatter.setDefaultEndDatesUpdated();

        if (this.user.IsPartSupplierUser) {
            this.searchSupplierNumber = this.user.SupplierNumber;
            this.searchExtendedSupplierNumber = this.user.ExtendedSupplierNumber;
        }
        this.getPruList();
        this.reset_filter();
    }
    reset_filter() {
        this.searchRegion = this.allRegions.values[0];
      }

    handleSearchFilter(element: any){

        let sequenceCheck: HTMLInputElement = (document.getElementById("searchSequenceInstructionInResult") as HTMLInputElement)
        let packagingCheck: HTMLInputElement = (document.getElementById("searchPackagingInstructionInResult") as HTMLInputElement)
        if(!sequenceCheck.checked && !packagingCheck.checked) {
            sequenceCheck.checked = true
            packagingCheck.checked = true
            alert("You have to select atleast one Packaging Type")
        }
    }

    ngAfterContentChecked() {

        this.isFocusSet = this.setFocus.to('partnumber', this.isFocusSet);
    }


    // ----------------------------------------------------------
    // Fetch form data
    // ----------------------------------------------------------
    getPruList() {
        this.pruList = [];
        this.pkgSearchService.GetPruList()
            .subscribe(returnObject => this.getPruListResult(returnObject));
    }

    getPruListResult(returnObject: IReturnObject) {
        if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'DashboardComponent.getPartPruUpdatesResult', returnObject.ErrorType);
        } else {
            this.pruList = <AttributeListBE[]>returnObject.DataList;
            //this.pruList = this.pruList.filter(item => item.Description.toLowerCase().includes('missing') === false);
        }
    }
    todisplay: number | null=null;
    toexpand: boolean=false;
    expanddetail(pos : number)
    {
        if(this.todisplay===pos)
        {
            this.toexpand=!this.toexpand;  
            
        }
        else{
            this.todisplay=pos;
            this.toexpand=true;
        }
    }
    
    getStatuses() {
        this.errHandler.emitErrorObject(null);
        this.pkgSearchService.getStatuses()
            .subscribe(returnObject => this.getStatusesResponse(returnObject));
    }

    getStatusesResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingComponent.getStatusesResponse', returnObject.ErrorType);
        } else {
            this.statusesList = returnObject.DataList.filter(x => x.Description !== 'Obsolete');
            this.statusesList = this.statusesList.filter(x => x.Description !== 'Phasing Out');
            this.setDefaultStatusSelection();
        }
        this.showSpinner = false;
    }

    setDefaultStatusSelection() {
        this.searchStatusIds = [];
        this.statusesList.forEach(item => {
            if (item.Description.toLowerCase().indexOf('scrapped') === -1) {
                this.searchStatusIds.push(item.Id);
            }
        });
    }


    // ----------------------------------------------------------
    // Get pdf for selected PI in list
    // ----------------------------------------------------------
    //PAIT-814
    getPDF(docVal: InstructionsListBE) {
        if(docVal.PackagingType == 2)
        {
          let change :string;
          change=docVal.PartDescription.replace(/"/g,' ');
          this.piName = docVal.PartNo + ' ' + change;
          const url = this.config.get('apiUrl')
              + '/SequenceInstruction/GetPreviewPdfSI/?siId='
              + docVal.Id
              + '&SIName='
              + this.piName;
          window.open(url, '_blank');
        }
        else{
          let change :string;
          change=docVal.PartDescription.replace(/"/g,' ');
          this.piName = docVal.PartNo + ' ' + change;
          const url = this.config.get('apiUrl')
              + '/PackaginInstruction/GetPreviewPdf/?piId='
              + docVal.Id
              + '&piName='
              + this.piName;
          window.open(url, '_blank');
        }
      }
    // getPDF(docVal: InstructionsListBE) {
    //   if(docVal.PackagingType == 2)
    //   {
    //     this.piName = docVal.PartNo + ' ' + docVal.PartDescription;
    //     const url = this.config.get('apiUrl')
    //         + '/SequenceInstruction/GetPreviewPdfSI/?siId='
    //         + docVal.Id
    //         + '&SIName='
    //         + this.piName;
    //     window.open(url, '_blank');
    //   }
    //   else{
    //     this.piName = docVal.PartNo + ' ' + docVal.PartDescription;
    //     const url = this.config.get('apiUrl')
    //         + '/PackaginInstruction/GetPreviewPdf/?piId='
    //         + docVal.Id
    //         + '&piName='
    //         + this.piName;
    //     window.open(url, '_blank');
    //   }
    // }


    // ----------------------------------------------------------
    // Search
    // ----------------------------------------------------------
    searchResult(returnObject: IReturnObject) {
        this.listOfPI = null;
        this.searchIsExecuting = false;
        if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
            this.error(returnObject.ErrorMsg, 'PackagingSearchComponent.searchResult', returnObject.ErrorType);
        } else {
            this.listOfPI = returnObject.DataList;
            this.sort();

            this.listOfUniquePI = this.listOfUniquePI || [];
            this.listOfAllPI=this.listOfAllPI  ||[];
            this.previousID=null;
        for(const item of this.listOfPI)
            {
                if(item.Id!==this.previousID)
                {
                    this.listOfUniquePI.push({Id: item.Id,
                        CreatedDate: item.CreatedDate,
                        StartDate: item.StartDate,
                        PartNo: item.PartNo,
                        PartDescription: item.PartDescription,
                        SupplierNo: item.SupplierNo,
                        SupplierName: item.SupplierName,
                        IssuerUserId: item.IssuerUserId,
                        StatusId: item.StatusId,
                        StatusDescription: item.StatusDescription,
                        IsMultiPart: item.IsMultiPart,
                        PruName: item.PruName,
                        PackagingCode: item.PackagingCode,
                        HasSupplierRelation: item.HasSupplierRelation,
                        PackagingType:item.PackagingType,
                        Region:item.Region});
                        this.previousID=item.Id;
                    
                }
                this.listOfAllPI.push({Id: item.Id,
                    CreatedDate: item.CreatedDate,
                    StartDate: item.StartDate,
                    PartNo: item.PartNo,
                    PartDescription: item.PartDescription,
                    SupplierNo: item.SupplierNo,
                    SupplierName: item.SupplierName,
                    IssuerUserId: item.IssuerUserId,
                    StatusId: item.StatusId,
                    StatusDescription: item.StatusDescription,
                    IsMultiPart: item.IsMultiPart,
                    PruName: item.PruName,
                    PackagingCode: item.PackagingCode,
                    HasSupplierRelation: item.HasSupplierRelation,
                    PackagingType:item.PackagingType,
                    Region:item.Region});
            }
          //  this.listOfAllPI=this.listOfPI;
         this.listOfPI=this.listOfUniquePI;
          this.sort();
            // console.log(this.listOfUniquePI); 
            // console.log(this.listOfAllPI); 


            this.collectionSize = this.listOfPI.length;
            this.collectionSize1=this.listOfAllPI.length;
            if (this.collectionSize > 0) {
                this.pageChanger();
            }
            else{
              this.openOnSearchValidateDlg("There is no instruction with this part number") ;
            }
        }
        this.searchIsExecuting = false;
        this.showSpinner = false;
    }

    openOnSearchValidateDlg(text: string) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "savefail";
        this.dialogBtnType = "info";
        this.dialogAppliesTo = 'Search Instruction';
        this.confirmDlgText = text;
        this.dialogAppliesToId = -1;
        this.currentDlg = this.modalService.open(this.validate, { size: 'sm' });
      }
    isSearchValid():boolean{
        this.searchIssuerUserName=this.searchIssuerUserName.trim();
       
        var splitIssuer=this.searchIssuerUserName.split(" ");
        if(this.searchIssuerUserName.length>0)
        {
            if(splitIssuer.length<2)
            {
                this.openOnSearchValidateDlg("Issuer user name must contain both first and last name.") ;
                return false;
            }

        }
        return true;
    }
    cancel() {
       this.currentDlg.close()
    }
    search() {
        if (this.isBasicSearchFieldsEmptyOrShort()) {
            const result = confirm('This is potentially a very lengthy operation (1 to 10 minutes). Do you want to continue?');
            if (!result) {
                return;
            }
        }
         if(this.isSearchValid()){
           // const result = confirm('Issuer user name must contain both first and last name');
            //if (!result||result) {
              //  return false;
            //}
            this.doSearch();
            this.toexpand=false;      
        }
    }

    doSearch() {
        this.searchIsExecuting = true;
        const createdDateFrom = this.dateFormatter.format(this.searchCreatedDateFrom);
        const createdDateTo = this.dateFormatter.format(this.searchCreatedDateTo);
        const includeNullDates = this.user.IsPartSupplierUser
            ? true
            : this.inlcludeNullCreatedDateInResult;
        const excludeSuppl = this.user.IsPartSupplierUser
            ? false
            : this.excludeSupplier && this.searchSupplierNumber.length > 0;
            var typeFilter=this.searchPackagingInstructionInResult?1:2;
        if(this.searchPackagingInstructionInResult&&this.searchSequenceInstructionInResult)
         typeFilter=3;
         

        this.showSpinner = true;
        this.pagerPage = 1;
        this.collectionSize = 0;
        this.filterText = '';
        this.listOfPI = null;
        this.listOfUniquePI=null;
        this.listOfAllPI=null;
        this.pagePiData = [];
        this.pagePiData1=null;
        this.pagePiData2=null;
        this.listOfPITemp = null;
        this.filterField = '';

        // if(this.selectedRegionValue = 1)
        // this.excludeSupplier == true;       

        this.pkgSearchService.listOfPi(this.searchPartNo,
            this.searchPartName,
            this.user.IsPartSupplierUser,
            this.searchSupplierNumber,
            this.searchExtendedSupplierNumber,
            this.searchSupplierName,
            this.searchStatusIds.join(','),
            this.searchIssuerUserId,
            this.searchMHNO,
            createdDateFrom,
            createdDateTo,
            includeNullDates,
            this.searchUnit,
            this.searchIssuerUserName,
            excludeSuppl,
            this.includePI,
            typeFilter,
            this.selectedRegionValue
            )
            .subscribe(returnObject => this.searchResult(returnObject));
            // console.log(this.listOfPI)
    }


    // ----------------------------------------------------------
    // Pagination methods
    // ----------------------------------------------------------
    arr2: String[] = new Array();
    arr3:String[]=new Array();
    pageChanger() {
        this.showSpinner = true;
       //console.log(this.numToSkip1);
       this.toexpand=false;
        const numToSkip = (this.pagerPage - 1) * this.paginationConfig.pageSize;
        const lastPageCount = this.collectionSize % 30;
        
        this.numPages = Math.ceil(this.collectionSize / this.paginationConfig.pageSize);
        
        this.pagePiData = [];
        this.pagePiData1=[];//IT IS USED TO REMOVE THE SLOWNESS IN THE PAGE FOR ITREATING THE WHOLE LIST LISTOFALLPI IN THE HTML
        this.arr2=[];// TO MAKE THE VALUE NULL FOR THE DECESRPITION AND PRU NAME BUT WILL WORK WITHOUT THAT AS WELL
        this.arr3=[];// TO MAKE THE VALUE NULL FOR THE SI Name BUT WILL WORK WITHOUT THAT AS WELL
        if (this.pagerPage === this.numPages && lastPageCount !== 0) {
            for (let i = numToSkip; i < numToSkip + lastPageCount; i++) {

                this.pagePiData.push(this.listOfPI[i]);
                this.getMoreinformation(this.listOfPI[i].Id);//USED FOR PAGEPIDATA1
               this.makenewdescription(this.listOfPI[i].Id,i,this.listOfPI[i].PartNo,this.listOfPI[i].SupplierNo,this.listOfPI[i].PackagingType);
               this.togetinstructionname(this.listOfPI[i].Id,this.listOfPI[i].PartNo,this.listOfPI[i].PackagingType);
            }
        } else {
            for (let i = numToSkip; i < numToSkip + 30; i++) {
                this.pagePiData.push(this.listOfPI[i]);
                this.getMoreinformation(this.listOfPI[i].Id);//Used for pagepidata1                
                this.makenewdescription(this.listOfPI[i].Id,i,this.listOfPI[i].PartNo,this.listOfPI[i].SupplierNo,this.listOfPI[i].PackagingType);
                 this.togetinstructionname(this.listOfPI[i].Id,this.listOfPI[i].PartNo,this.listOfPI[i].PackagingType);
                // console.log(this.listOfPI[i].Id,this.listOfPI[i].PartNo,this.listOfPI[i].SupplierNo)                
                //console.log(this.arr2[this.listOfPI[i].Id]);
                
                //console.log(numToSkip);
            }
        }
    //    console.log(this.pagePiData1);
       
       //console.log(this.pagePiData.length);
        
        // console.log(this.pagePiData1);
      
     this.showSpinner = false;
    }
       
    toshownewdescription(k:number):string
    {
        // var str: String = new String(this.arr2[k]);
       
       var str: string = String(this.arr2[k]);
         
        return str;
       
     }
    makenewdescription(id:number,j:number,No:string,SupplierNumber:number,type:number)
    {
         //debugger; 
        let consubstringfinder:string;
       let doingone:string="";
        if(type===1)
        {
        for(const item of this.listOfAllPI)
       {        
        if(item.Id===id)
        {
            consubstringfinder=item.PruName;
            consubstringfinder=consubstringfinder.substring(0,3);
            if(consubstringfinder.includes("-"))
            {
                consubstringfinder=consubstringfinder.substring(0,consubstringfinder.length-1);  
            }
            doingone=doingone+consubstringfinder+",";    
            
        }
        } 
       }
       if(type===2)
       {
        for(const item of this.listOfAllPI)
        {        
         if(item.Id===id&&item.PartNo===No&&item.SupplierNo===SupplierNumber)
         {
             consubstringfinder=item.PruName;
             consubstringfinder=consubstringfinder.substring(0,3);
             if(consubstringfinder.includes("-"))
             {
                 consubstringfinder=consubstringfinder.substring(0,consubstringfinder.length-1);  
             }
             doingone=doingone+consubstringfinder+",";    
             
         }
         } 
       }
       doingone=doingone.substring(0,doingone.length-1); 
       this.arr2[id]=doingone;
    //   console.log(this.arr2);
    }
    toshownewinstructionname(k:number):string
     {
       // var str: String = new String(this.arr2[k]);
       
       var str: string = String(this.arr3[k]);
         
        return str;
       
     }
    togetinstructionname(id:number,Name:String,type:number)
    {
           if(type==1)
           {
                  this.arr3[id]=Name;
           }
           else{
            if(this.user.IsPartSupplierUser)
            {
               this.arr3[id]=Name;
            }
            else{
                var str=Name.lastIndexOf('/');
                this.arr3[id]=Name.substring(0,str);
                
            }
           }
        //    console.log(this.arr3);
    }
   getMoreinformation(id:number)    {
        this.pagePiData1=this.pagePiData1  ||[];
        this.listOfAllDistinctPI=this.listOfAllDistinctPI ||[];
        for(const item of this.listOfAllPI)            
        {
            if(item.Id===id)
            {                     
                        this.pagePiData1.push({Id: item.Id,
                        CreatedDate: item.CreatedDate,
                        StartDate: item.StartDate,
                        PartNo: item.PartNo,
                        PartDescription: item.PartDescription,
                        SupplierNo: item.SupplierNo,
                        SupplierName: item.SupplierName,
                        IssuerUserId: item.IssuerUserId,
                        StatusId: item.StatusId,
                        StatusDescription: item.StatusDescription,
                        IsMultiPart: item.IsMultiPart,
                        PruName: item.PruName,
                        PackagingCode: item.PackagingCode,
                        HasSupplierRelation: item.HasSupplierRelation,
                        PackagingType:item.PackagingType,
                        Region:item.Region});
                        this.previousID=item.Id;
            }               
        }
    }
    
    // ----------------------------------------------------------
    // sortandfilter bar methods
    // ----------------------------------------------------------
    nextPageChanger(step: number) {
        // negative number moves back, positive moves next
        this.pagerPage = this.pagerPage + step;
        this.pageChanger();
    }

    firstPageChanger() {
        this.pagerPage = 1;
        this.pageChanger();
    }

    lastPageChanger() {
        this.pagerPage = this.numPages;
        this.pageChanger();
    }

    filterFieldChange() {
        this.showSpinner = true;
        if (this.filterField === '' && this.listOfPITemp !== null) {
            // Reset filter and show all rows if no filter field is selected
            this.listOfPI = this.listOfPITemp;
            this.collectionSize = this.listOfPI.length;
            this.listOfPITemp = null;
            this.filterText = '';
            this.pageChanger();
        } else if (this.filterText !== '') {
            this.applyFilter();
        }
        this.showSpinner = false;
    }

    applyFilter() {
        this.showSpinner = true;
        this.pagerPage = 1;
        if (this.filterText === '') {
            // Remove filter and reset if no filter string is empty
            this.listOfPI = this.listOfPITemp;
            this.collectionSize = this.listOfPI.length;
            this.listOfPITemp = null;
            this.pageChanger();
            return;
        }

        if (this.listOfPITemp === null) {
            // If its the first character in filter then tem is empty so set it
            this.listOfPITemp = this.listOfPI;
        }

        // Filter out item according to filter text
        const that = this;
        this.listOfPI = this.listOfPITemp.filter(item => {
            if (item[that.filterField] !== null) {
                if (that.filterField !== 'IsMultiPart') {
                    return item[that.filterField].toLowerCase().includes(that.filterText.toLowerCase());
                } else {
                    return that.filterText === '1' && item[that.filterField] === true ? true : false;
                }
            }
        });
        this.collectionSize = this.listOfPI.length;
        this.pageChanger();
    }

    sortBy(fieldToSortBy: string) {
        if (this.sortField !== fieldToSortBy) {
            // If another column is clicked, set default to asc
            this.sortOrder = 'asc';
            this.sortField = fieldToSortBy;
        } else {
            // Toggle asc / desc
            this.sortOrder = this.sortOrder === 'asc'
                ? 'desc'
                : 'asc';
        }
        this.sort().then(() => {
            this.pagerPage = 1;
            this.pageChanger();
        });
    }

    async sort() {
        this.listOfPI.sort((a, b) => {
            if (this.sortField === 'CreatedDate') {
                // Date sort
                const left = Number(new Date(a[this.sortField]));
                const right = Number(new Date(b[this.sortField]));
                return (this.sortOrder === 'asc')
                    ? left - right
                    : right - left;
            } else if (this.sortField === 'StatusId') {
                // Numeric sort
                return (this.sortOrder === 'asc')
                    ? a[this.sortField] - b[this.sortField]
                    : b[this.sortField] - a[this.sortField];
            } else if (this.sortField === 'IsMultiPart') {
                // Boolean sort
                const left = a[this.sortField] === false ? 0 : 1;
                const right = b[this.sortField] === false ? 0 : 1;
                return (this.sortOrder === 'asc')
                    ? right - left
                    : left - right;
            } else {
                // string sort
                const aVal = a[this.sortField] === null
                    ? ''
                    : a[this.sortField].toLowerCase();

                const bVal = b[this.sortField] === null
                    ? ''
                    : b[this.sortField].toLowerCase();

                if (aVal < bVal) {
                    return (this.sortOrder === 'asc') ? -1 : 1;
                } else if (aVal > bVal) {
                    return (this.sortOrder === 'asc') ? 1 : -1;
                } {
                    return 0;
                }
            }
        });
    }


    // ----------------------------------------------------------
    // Excel download methods
    // ----------------------------------------------------------
    downloadExcel() {
        window.open(this.config.get('apiUrl') + '/PackaginInstruction/CreatePIListExcel/', '_blank');
    }
    downloadExcelSI(){
        window.open(this.config.get('apiUrl') + '/SequenceInstruction/CreateSIListExcel/', '_blank');

    }

    isBasicSearchFieldsEmptyOrShort() {
        const searchVal = this.searchPartNo.trim()
            + this.searchPartName.trim()
            + this.searchSupplierNumber.trim()
            + this.searchExtendedSupplierNumber
            + this.searchSupplierName.trim()
            + this.searchIssuerUserId.trim()
            + this.searchIssuerUserName.trim()
            + this.MHNOLength();
        return searchVal.length <= 1;
    }

    MHNOLength() {
        return this.searchMHNO.toLocaleLowerCase().trim() === 'm'
            || this.searchMHNO.toLocaleLowerCase().trim() === 'mh'
            || this.searchMHNO.toLocaleLowerCase().trim() === 'mhn'
            || this.searchMHNO.toLocaleLowerCase().trim() === 'mhno'
            ? 0
            : this.searchMHNO.trim().length;
    }

    downloadCurrentExcel() {
        if (this.isBasicSearchFieldsEmptyOrShort()) {
            const result = confirm('This is potentially a very lengthy operation (1 to 10 minutes). Do you want to continue?');
            if (!result) {
                return;
            }
        }
        this.doDownloadCurrentExcel();
    }

    doDownloadCurrentExcel() {
        const createdDateFrom = this.dateFormatter.format(this.searchCreatedDateFrom);
        const createdDateTo = this.dateFormatter.format(this.searchCreatedDateTo);
        const includeDates = this.user.IsPartSupplierUser
            ? false
            : this.inlcludeNullCreatedDateInResult;
        const excludeSuppl = this.user.IsPartSupplierUser
            ? false
            : this.excludeSupplier;
        const typeFilter = this.searchPackagingInstructionInResult ? 1 :
            this.searchSequenceInstructionInResult ? 2 : 3;

        const url = this.config.get('apiUrl')
            + '/PackaginInstruction/ListOfPiforExcel/?partNumber=' + this.searchPartNo
            + '&partName=' + this.searchPartName
            + '&isSupplierUSer=' + this.user.IsPartSupplierUser
            + '&supplierNumber=' + this.searchSupplierNumber
            + '&extendedSupplierNumber=' + this.searchExtendedSupplierNumber
            + '&supplierName=' + this.searchSupplierName
            + '&statusListId=' + this.searchStatusIds.join(',')
            + '&issuerUserId=' + this.searchIssuerUserId
            + '&searchMHNO=' + this.searchMHNO
            + '&createdDateFrom=' + createdDateFrom
            + '&createdDateTo=' + createdDateTo
            + '&inlcludeDateSpansInSearch=' + includeDates
            + '&sortByColumn=' + this.sortField
            + '&sortOrder=' + this.sortOrder
            + '&unit=' + this.searchUnit
            + '&issuerUserName=' + this.searchIssuerUserName
            + '&excludeSupplier=' + excludeSuppl
            + '&includePI=' + this.includePI
            + '&region=' + this.selectedRegionValue
            + '&typeFilter=' + typeFilter
            ;
        window.open(url, '_blank');
    }

    // ----------------------------------------------------------
    // Error, warning and info
    // ----------------------------------------------------------
    error(message: string, source: string, errType: ErrorTypeEnum): void {
        throw new ErrorObject(message, source, errType);
    }


    // ----------------------------------------------------------
    // Misc logic
    // ----------------------------------------------------------
    setDefaultCreateDates() {
        this.searchCreatedDateFrom = this.dateFormatter.parse('1991-01-01');
        this.searchCreatedDateTo = this.dateFormatter.parse('2024-12-31');

        //const dt = new Date();
        //this.searchCreatedDateTo.year = dt.getFullYear() + 5;
    }

    reset() {
        this.searchPartNo = '';
        this.searchPartName = '';
        this.searchSupplierNumber = this.user.IsPartSupplierUser ? this.searchSupplierNumber : '';
        this.searchExtendedSupplierNumber = this.user.IsPartSupplierUser ? this.searchExtendedSupplierNumber : '';
        this.searchSupplierName = '';
        this.searchIssuerUserId = '';
        this.searchIssuerUserName = '';
        this.searchUnit = '-1';
        this.searchMHNO = '';

        this.setDefaultCreateDates();
        this.setDefaultStatusSelection();
        this.filterField = '';
        this.filterFieldChange();
    }

    isValidSupplier(): boolean {
        const isValidSupplier = this.user.IsPartSupplierUser
            ? (this.user.SupplierNumber !== null || this.user.SupplierNumber !== '0')
            : true;
        return isValidSupplier;
    }

    showSearchForm(): boolean {
        const isValidSupplier = this.isValidSupplier();
        const isScaniaRole = !this.user.IsSupplierProposals && !this.user.IsPartSupplierUser;
        return isScaniaRole || isValidSupplier;
    }

    canExport() {
        const canExport = this.user.IsPackagingAdmin
            || this.user.IsDeveloper
            || this.user.IsPackagingEngineer
            || this.user.IsPurchaser;

        return canExport;
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/packaging-instruction-search/packaging-instruction-search.component.ts